import { css } from "styled-components";

export const appLayoutStyles = css`
    &.aevi-master {
        width: 100%;
        overflow: hidden;
        background-color: white;
        text-align: left;
    }
`;
